import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);


const routes = [
{
    path: "/jobs",
    name: "jobs",
    component: () => import(  "@/views/job.vue"),
},
{
    path: "/jobs/detail/:id",
    name: "detail",
    component: () => import(  "@/views/job-detail.vue"),
},
{
    path: "/",
    name: "pc",
    component: () => import(  "@/views/pc2.vue")
}
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});
export default router;